module.exports = __webpack_public_path__ + "img/kz_dostup_k_informacii_1.6ef07722.png";